import { TMessageType } from "../InfoMessageComponent/InfoMessageComponent";

export const INFO_MESSAGES_STR: Record<
  Exclude<TMessageType, "redirecting">,
  string
> = {
  info: "DEV NOTES: THIS MESSAGE IS HARD CODED DUE TO FONT WEIGHT REQUIREMENTS",
  "file-size-error":
    "File size exceeds 2.5MB. Please upload a file no larger than 2.5MB.",
  "file-type-error": "Invalid file type. Please upload a .xlsx file.",
  "uploading-error": "Error(s) were found during the upload."
};

export const MAX_UPLOAD_FILE_SIZE = 2621440;
